export const cancelInputEvent = (event: any, usePreventAndPropagation = true): boolean => {
  const targetElement = event.target.tagName?.toUpperCase();

  if (targetElement === 'INPUT' || targetElement === 'TEXTAREA') {
    if (usePreventAndPropagation) {
      event.preventDefault();
      event.stopPropagation();
    }

    return true;
  }

  return false;
};
